import React, { useState } from 'react'
import MultiSelect from 'react-multiple-select-dropdown-lite'
import bitsFetch from '../components/Childs/bitsFetch'
import LoaderSm from '../components/Childs/LoaderSm'
import SnackMsg from '../components/Childs/SnackMsg'

export default function ImportData({ wcStatus }) {
  // eslint-disable-next-line no-undef
  const isPro = typeof bit_wc_zoho_inventory !== 'undefined' && bit_wc_zoho_inventory.isPro
  const [importDataOptions, setImportDataOptions] = useState({ importType: 'contact' })
  const [snack, setSnackbar] = useState({ show: false })
  const [isLoading, setIsLoading] = useState(false)
  const handleInput = (name, val) => {
    const tmp = { ...importDataOptions }
    tmp[name] = val
    if (name === 'importType' && !isPro) {
      tmp.importType = 'contact'
    }
    setImportDataOptions(tmp)
  }
  const handleImportData = () => {
    setIsLoading(true)
    bitsFetch({ importDataOptions }, 'bit_import_order_data')
      .then(result => {
        setSnackbar({ show: true, msg: result.data })
        setIsLoading(false)
      })
  }
  return (
    <div className="btcd-s-wrp">
      <SnackMsg snack={snack} setSnackbar={setSnackbar} />
      <b className="wdt-150 d-in-b">Start Date:</b>
      <input type="date" className="btcd-paper-inp w-3 mr-4" name="start_date" onChange={e => handleInput(e.target.name, e.target.value)} />
      <br />
      <br />
      <b className="wdt-150 d-in-b">End Date:</b>
      <input type="date" className="btcd-paper-inp w-3" name="end_date" onChange={e => handleInput(e.target.name, e.target.value)} />
      <br />
      <br />
      <div className="flx">
        <b className="wdt-150 d-in-b">Order Status:</b>
        <MultiSelect
          className="btcd-paper-drpdwn w-3"
          onChange={val => handleInput('status', val)}
          options={Object.entries(wcStatus).map(status => ({ label: status[1], value: status[0] }))}
        />
      </div>
      <br />
      <br />
      <b className="wdt-150 d-in-b">Import Type:</b>
      <label htmlFor="contact" className="mr-2">
        <input id="contact" type="radio" name="importType" onChange={e => handleInput(e.target.name, 'contact')} checked={importDataOptions.importType === 'contact'} />Import Contact
      </label>
      <label htmlFor="contactsales" className="pos-rel">
        <input id="contactsales" type="radio" name="importType" onChange={e => handleInput(e.target.name, 'contactsales')} disabled={!isPro} />Import Contact & Sales Order
        {!isPro && <span className="pro-chip">pro</span>}
      </label>
      <br />
      <button className="btn btcd-btn-lg green sh-sm flx" type="button" onClick={handleImportData} disabled={isLoading}>
        Import{isLoading && 'ing'} Data{isLoading && '...'} &nbsp;
        <div className="btcd-icn icn-arrow_back rev-icn d-in-b" />
        {isLoading && <LoaderSm size="20" clr="#022217" className="ml-2" />}
      </button>
    </div>
  )
}